(() => {
  const containerSelector = '.dt-og-cart-wallets';
  const walletSelector = 'shopify-accelerated-checkout-cart';
  const mobileQuery = window.matchMedia('(max-width: 768px)');
  const skeleton = '<div class="wallet-button-wrapper"><ul class="wallet-cart-grid wallet-cart-grid--skeleton" role="list" data-shopify-buttoncontainer="true"><li data-testid="grid-cell" class="wallet-cart-button-container"><div class="wallet-cart-button wallet-cart-button__skeleton" role="button" disabled aria-hidden="true">&nbsp;</div></li></ul></div>';

  const getContainers = (scope) => {
    const containers = [];

    if (scope instanceof Element && scope.matches(containerSelector)) {
      containers.push(scope);
    }

    if (scope.querySelectorAll) {
      containers.push(...scope.querySelectorAll(containerSelector));
    }

    return containers;
  };

  const restoreNativeLayout = (container) => {
    container.querySelector('.dt-og-cart-wallet-grid')?.remove();

    const source = container.querySelector(`${walletSelector}[data-dt-og-wallet-source]`);

    if (source) {
      source.hidden = false;
      source.removeAttribute('data-dt-og-wallet-source');
    }
  };

  const createWallet = (source, config) => {
    const inertDocument = document.implementation.createHTMLDocument('');
    const wallet = inertDocument.createElement(source.localName);

    for (const attribute of source.attributes) {
      if (attribute.name !== 'hidden' && attribute.name !== 'data-dt-og-wallet-source') {
        wallet.setAttribute(attribute.name, attribute.value);
      }
    }

    wallet.setAttribute('wallet-configs', JSON.stringify([config]));
    wallet.setAttribute('data-dt-og-wallet-clone', '');
    wallet.innerHTML = skeleton;

    return document.adoptNode(wallet);
  };

  const applyMobileGrid = (container) => {
    if (!mobileQuery.matches) {
      restoreNativeLayout(container);
      return;
    }

    if (container.querySelector('.dt-og-cart-wallet-grid')) {
      return;
    }

    const content = container.querySelector('.dynamic-checkout__content') || container;
    const source = content.querySelector(`${walletSelector}:not([data-dt-og-wallet-clone])`);

    if (!source) {
      return;
    }

    let configs;

    try {
      configs = JSON.parse(source.getAttribute('wallet-configs') || '[]');
    } catch {
      return;
    }

    if (!Array.isArray(configs) || configs.length < 2) {
      return;
    }

    const grid = document.createElement('div');
    grid.className = 'dt-og-cart-wallet-grid';

    configs.forEach((config, index) => {
      const cell = document.createElement('div');
      cell.className = 'dt-og-cart-wallet-cell';

      if (configs.length % 2 === 1 && index === configs.length - 1) {
        cell.classList.add('dt-og-cart-wallet-cell--wide');
      }

      cell.append(createWallet(source, config));
      grid.append(cell);
    });

    source.setAttribute('data-dt-og-wallet-source', '');
    source.hidden = true;
    content.append(grid);
  };

  const refreshLayout = (scope = document) => {
    getContainers(scope).forEach(applyMobileGrid);
  };

  const scheduleRefresh = (scope = document) => {
    window.requestAnimationFrame(() => refreshLayout(scope));
  };

  [
    'cart:build',
    'cart:refresh',
    'cart:updated',
    'ajaxProduct:added',
    'shopify:cart:lines-update'
  ].forEach((eventName) => {
    document.addEventListener(eventName, () => scheduleRefresh());
  });

  document.addEventListener('shopify:section:load', (event) => scheduleRefresh(event.target));
  mobileQuery.addEventListener('change', () => scheduleRefresh());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleRefresh(), { once: true });
  } else {
    scheduleRefresh();
  }
})();
